import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import mlEngineer from '../../../js/pages/JobsListPage/mlEngineerJobs';

const Page = () => <JobsListPage role={mlEngineer} />;

export default Page;
